"use strict";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { makeSelectHasTokenFavorited } from "features/favorites/selectors";
export function useSelectHasTokenFavorited(currencyId) {
  const selectHasTokenFavorited = useMemo(makeSelectHasTokenFavorited, []);
  return useSelector((state) => selectHasTokenFavorited(state, currencyId.toLowerCase()));
}
